// extracted by mini-css-extract-plugin
var _1 = "S3Lmh";
export { _1 as "base" }
